export const fr = {
  returnRequestDate: {
    label: "Votre demande de retour a été faite le {{date}} à {{time}}",
  },
  actions: {
    continue: "Continuer",
  },
  "order-identification": {
    title: "Suivez votre commande",
    description: "Entrez les détails de votre commande pour suivre votre colis",
    fields: {
      "zip-code": {
        title: "Code postal",
        description: "Entrez votre code postal de livraison",
        required: "Le code postal est obligatoire",
      },
      email: {
        title: "Adresse email",
        description: "Entrez l'adresse email utilisée pour votre commande",
        required: "L'adresse email est obligatoire",
      },
      "tracking-number": {
        title: "Numéro de commande",
        description: "Entrez votre numéro de commande",
        required: "Le numéro de commande est obligatoire",
      },
    },
    errors: {
      "unknown-order": {
        title: "Numéro de commande inconnu",
        description:
          "Le numéro de commande n'a pas été trouvé, veuillez le vérifier",
      },
      "order-not-shipped": {
        title: "Commande en préparation",
        description: "Votre commande n'est pas encore expédiée",
      },
      "search-error": {
        title: "Erreur lors de la recherche",
        description:
          "Nous n'avons pas pu trouver la commande. Veuillez réessayer plus tard.",
      },
    },
  },
  delivery: "Livraison",
  "parcel-history": "Historique du colis",
  "order-details": {
    title: "Détails de la commande",
    "tracking-number": "Numéro de suivi",
    "order-number": "Numéro de commande",
  },
  tracking: {
    shared: {
      estimatedDeliveryDate: "Date de livraison estimée",
      deliveredOn: "Livré le",
      from: "du",
      to: "au",
    },
  },
  deliveryAddress: {
    title: "Adresse de livraison\u00A0:",
    titlePickup: "Adresse du point de retrait\u00A0:",
    orderDetails: {
      title: "Détails de la commande\u00A0:",
      trackingNumber: "Numéro de suivi\u00A0:",
      orderNumber: "Numéro de commande\u00A0:",
      orderDate: "Date de commande\u00A0:",
    },
  },
  pickupPoint: {
    title: "Point relais",
    openingHours: "Horaires d'ouverture\u00A0:",
    closed: "Fermé",
    directions: "Itinéraire",
    days: {
      monday: "Lundi\u00A0:",
      tuesday: "Mardi\u00A0:",
      wednesday: "Mercredi\u00A0:",
      thursday: "Jeudi\u00A0:",
      friday: "Vendredi\u00A0:",
      saturday: "Samedi\u00A0:",
      sunday: "Dimanche\u00A0:",
    },
  },
  wallet: {
    warningNotEnabled:
      "Vous devez activer le Wallet dans les paramètres de votre boutique",
  },
  crossSell: {
    youMightAlsoLike: "Vous aimerez peut-être aussi",
  },
  "rate-order": {
    "order-recap": {
      title: "Votre commande",
      "tracking-label": "Numéro de suivi :",
      "order-label": "Numéro de commande :",
    },
    form: {
      title: "Évaluez votre livraison",
      "rating-label": "Notez votre expérience de livraison",
      "comment-label": "Commentaire (facultatif)",
      "comment-placeholder": "Partagez-nous votre expérience…",
      "submit-cta": "Envoyer mon évaluation",
      "update-cta": "Mettre à jour mon évaluation",
      "rating-required": "Veuillez sélectionner une note.",
    },
    "thank-you": {
      title: "Merci pour votre retour !",
      description:
        "Votre évaluation a bien été prise en compte. Elle nous aidera à améliorer l'expérience de livraison.",
    },
    errors: {
      "invalid-token": {
        title: "Lien invalide ou expiré",
        description:
          "Ce lien n'est plus valide. Ouvrez-le depuis votre dernier email de suivi.",
      },
      submit: {
        title: "Une erreur est survenue",
        description:
          "Nous n'avons pas pu enregistrer votre évaluation. Veuillez réessayer plus tard.",
      },
    },
  },
  returnLineItems: {
    refund: "Remboursement(s)",
    exchange: "Échange(s)",
    discount: "Remise(s)",
  },
  returnStoreAddress: {
    mapButton: "Voir sur la carte",
  },
  shippingInstructions: {
    colissimo:
      "Vous pouvez à présent imprimer votre étiquette de retour et déposer votre colis dans le relais Colissimo le plus proche.",
    chronoShop2Shop:
      "Vous pouvez à présent imprimer votre étiquette de retour et déposer votre colis dans le relais Chronopost le plus proche.",
    ups: "Vous pouvez à présent imprimer votre étiquette de retour et déposer votre colis dans le relais UPS le plus proche.",
    customerCarrier:
      "Vous pouvez à présent envoyer votre colis de retour au transporteur de votre choix.",
    merchantCarrier:
      "Nous vous enverrons une étiquette de retour par email dans les 1 à 3 jours ouvrés.",
    returnToStore:
      "Vous pouvez à présent imprimer votre étiquette de retour et déposer votre colis dans le magasin le plus proche.",
    malca:
      "Vous pouvez à présent imprimer votre étiquette de retour et déposer votre colis dans le relais Malca le plus proche.",
    tnt: "Vous pouvez à présent imprimer votre étiquette de retour et déposer votre colis dans le relais TNT le plus proche.",
    bonDeRetour:
      "Votre bon de retour est prêt. Vous pouvez dès à présent l'imprimer et l'utiliser pour votre retour.",
  },
  downloadLabel: {
    label: "Télécharger mon étiquette",
    bonDeRetour: "Télécharger mon bon de retour",
  },
  shippingInstructionsTitle: {
    shippingLabel: "Votre étiquette d'expédition est prête",
    bonDeRetour: "Votre bon de retour est prêt",
  },
} as const;
